import React from 'react';
import { isString } from 'underscore';
import { IconButton } from '@fluentui/react';
import { HelpIcon } from '@bingads-webui-campaign-react/help';

export const AssetGroupColumn = ({ i18n, onEditAssetGroup }) => ({
  key: 'AssetGroup',
  name: i18n.getString(_TL_('Asset group')),
  fieldName: 'Name',
  className: 'column-asset-group',
  headerClassName: 'header-asset-group',
  minWidth: 120,
  maxWidth: 200,
  sortable: true,
  isMultiline: true,
  isResizable: true,
  onRenderAggregatedRow: ({ text, count, helpId }) => {
    const aggregatedName = isString(text) ?
      text.replace('{{number}}', count).replace('{{entity}}', i18n.getString(_TL_('asset groups'))) :
      i18n.getString(_TL_('-'));

    const helpIcon = isString(helpId) ? (
      <span className="grid-header-helpId">
        <HelpIcon topic={helpId} disabled />
      </span>
    ) : null;

    return (
      <div className="appads-column-aggregated-row">
        <div>{aggregatedName}</div>
        {helpIcon}
      </div>
    );
  },
  onRender: ({ Id, Name }) => (
    <div className="appads-column-asset-group">
      <div>{Name}</div>
      <IconButton
        iconProps={{ iconName: 'Edit' }}
        title={i18n.getString(_TL_('Edit asset group'))}
        onClick={() => onEditAssetGroup(Id)}
      />
    </div>
  ),
});
